import { NgModule } from '@angular/core';
import { CreditCardConversionRoutingModule } from './credit-card-conversion-routing.module';
import { CreditCardConversionComponent } from './credit-card-conversion.component';

import { CreditCardConversionBannerComponent } from './components/credit-card-conversion-banner/credit-card-conversion-banner.component';
import { CreditCardConversionBenefitsComponent } from './components/credit-card-conversion-benefits/credit-card-conversion-benefits.component';
import { CreditCardConversionLearnMoreComponent } from './components/credit-card-conversion-learn-more/credit-card-conversion-learn-more.component';
import { CreditCardConversionRewardCalculatorComponent } from './components/credit-card-conversion-reward-calculator/credit-card-conversion-reward-calculator.component';
import { CreditCardConversionHeaderComponent } from './components/credit-card-conversion-header/credit-card-conversion-header.component';
import { CreditCardConversionFooterComponent } from './components/credit-card-conversion-footer/credit-card-conversion-footer.component';
import { Input2, Modal, ValueSlider } from '@citi-gcg-173875/citi-common-ui';
import { MktCommonModule } from 'src/app/common/mkt-common.module';

@NgModule({
    imports: [
        MktCommonModule,
        CreditCardConversionRoutingModule,
        ValueSlider,
        Modal,
        Input2,
    
    ],
    declarations: [
        CreditCardConversionComponent,
        CreditCardConversionBannerComponent,
        CreditCardConversionBenefitsComponent,
        CreditCardConversionLearnMoreComponent,
        CreditCardConversionRewardCalculatorComponent,
        CreditCardConversionHeaderComponent,
        CreditCardConversionFooterComponent,
    ],
    providers: [
        
    ]
})
export class CreditCardConversionModule {

}
